module.exports = __webpack_public_path__ + "static/media/SP.b5761246.jpg";